import { gql } from "@apollo/client";

export const MUTATION_COMPLETE_TASK = gql`
  mutation completedTask($data: CompletedTaskInput!) {
    createCompletedTask(data: $data) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;
